import { Tabs } from 'antd';
import { ColumnsType } from 'antd/es/table';

import type {
  MagicFlowOption,
  RuleRow,
  RuleSetRunRecord,
  WorkflowTemplateRecord,
} from '../MagicFlowAdmin.types';
import { DebuggerTab } from './DebuggerTab';
import { RulesetTab } from './RulesetTab';
import { WorkflowTemplatesTab } from './WorkflowTemplatesTab';

type WorkflowTemplateTableRecord = WorkflowTemplateRecord & {
  key: string;
};

type RuleSetRunTableRecord = RuleSetRunRecord & {
  key: string;
};

type MagicFlowAdminTabsProps = {
  activeTab: string;
  onTabChange: (key: string) => void;
  hasOrgSelected: boolean;
  onAddRule: () => void;
  ruleRows: RuleRow[];
  ruleEditorColumns: ColumnsType<RuleRow>;
  isLoadingCurrentRuleSet: boolean;
  isFetchingCurrentRuleSet: boolean;
  hasUnsavedRuleChanges: boolean;
  isSavingRuleSet: boolean;
  onSaveRuleSet: () => void;
  onCreateTemplate: () => void;
  workflowTemplateTableData: WorkflowTemplateTableRecord[];
  templateColumns: ColumnsType<WorkflowTemplateRecord>;
  isLoadingTemplates: boolean;
  isFetchingTemplates: boolean;
  namespace: string;
  setNamespace: (value: string) => void;
  eventName: string;
  setEventName: (value: string) => void;
  eventId: string;
  setEventId: (value: string) => void;
  eventDataJson: string;
  setEventDataJson: (value: string) => void;
  namespaceOptions: MagicFlowOption[];
  isLoadingNamespaces: boolean;
  hasPublishErrors: boolean;
  isPublishingEvent: boolean;
  onPublishEvent: () => void;
  ruleSetRunsTableData: RuleSetRunTableRecord[];
  isLoadingRuleSetRuns: boolean;
  isFetchingRuleSetRuns: boolean;
  onRefreshRuleSetRuns: () => void;
};

export const MagicFlowAdminTabs = ({
  activeTab,
  onTabChange,
  hasOrgSelected,
  onAddRule,
  ruleRows,
  ruleEditorColumns,
  isLoadingCurrentRuleSet,
  isFetchingCurrentRuleSet,
  hasUnsavedRuleChanges,
  isSavingRuleSet,
  onSaveRuleSet,
  onCreateTemplate,
  workflowTemplateTableData,
  templateColumns,
  isLoadingTemplates,
  isFetchingTemplates,
  namespace,
  setNamespace,
  eventName,
  setEventName,
  eventId,
  setEventId,
  eventDataJson,
  setEventDataJson,
  namespaceOptions,
  isLoadingNamespaces,
  hasPublishErrors,
  isPublishingEvent,
  onPublishEvent,
  ruleSetRunsTableData,
  isLoadingRuleSetRuns,
  isFetchingRuleSetRuns,
  onRefreshRuleSetRuns,
}: MagicFlowAdminTabsProps) => {
  return (
    <Tabs
      className="mt-3"
      activeKey={activeTab}
      onChange={onTabChange}
      items={[
        {
          key: 'ruleset',
          label: 'Ruleset',
          children: (
            <RulesetTab
              hasOrgSelected={hasOrgSelected}
              onAddRule={onAddRule}
              ruleRows={ruleRows}
              ruleEditorColumns={ruleEditorColumns}
              isLoadingCurrentRuleSet={isLoadingCurrentRuleSet}
              isFetchingCurrentRuleSet={isFetchingCurrentRuleSet}
              hasUnsavedRuleChanges={hasUnsavedRuleChanges}
              isSavingRuleSet={isSavingRuleSet}
              onSaveRuleSet={onSaveRuleSet}
            />
          ),
        },
        {
          key: 'workflow-templates',
          label: 'Workflow Templates',
          children: (
            <WorkflowTemplatesTab
              hasOrgSelected={hasOrgSelected}
              onCreateTemplate={onCreateTemplate}
              workflowTemplateTableData={workflowTemplateTableData}
              templateColumns={templateColumns}
              isLoadingTemplates={isLoadingTemplates}
              isFetchingTemplates={isFetchingTemplates}
            />
          ),
        },
        {
          key: 'debugger',
          label: 'Debbuger',
          children: (
            <DebuggerTab
              hasOrgSelected={hasOrgSelected}
              namespace={namespace}
              setNamespace={setNamespace}
              eventName={eventName}
              setEventName={setEventName}
              eventId={eventId}
              setEventId={setEventId}
              eventDataJson={eventDataJson}
              setEventDataJson={setEventDataJson}
              namespaceOptions={namespaceOptions}
              isLoadingNamespaces={isLoadingNamespaces}
              hasPublishErrors={hasPublishErrors}
              isPublishingEvent={isPublishingEvent}
              onPublishEvent={onPublishEvent}
              ruleSetRunsTableData={ruleSetRunsTableData}
              isLoadingRuleSetRuns={isLoadingRuleSetRuns}
              isFetchingRuleSetRuns={isFetchingRuleSetRuns}
              onRefreshRuleSetRuns={onRefreshRuleSetRuns}
            />
          ),
        },
      ]}
    />
  );
};
